import { jsx as o } from "react/jsx-runtime";
const v = (h) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...h,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentcolor",
        d: "M17.158 21.4h-2.246V3h2.246zM12.101 18.495h-1.82c-1.937 0-2.848-1.085-2.848-2.867v-5.074H6v-2.13h1.433V5.672h2.654v2.75h2.15v2.13h-2.15v4.881c0 .66.252.93.949.93H12.1z"
      }
    )
  }
);
export {
  v as default
};
